const AdminFooter = () => {
    return (
        <div>
            
        </div>
    );
};

export default AdminFooter;